__webpack_require__.p = "/Isuru-Wickramasinghe/";